import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import withRouter from '../../../../helpers/withRouter';
import {
  Box,
  Button,
  Card,
  Checkbox,
  IconButton,
  Typography,
  CardContent,
} from '@material-ui/core';
import DataTable from 'react-data-table-component';
import ProjectTableHeader from './ProjectTableHeader';
import moment from 'moment';
import ProjectOptions from './ProjectOptions';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { withStyles } from '@material-ui/core/styles';
import ProjectStyles from '../../../../styles/jss/components/apps/ProjectStyles';
import { filterData, searchData } from '../../../../helpers';
import { Auth } from 'aws-amplify';
import axios from 'axios';
import { cfg } from '../../../../config';
import { NotificationManager } from 'react-notifications';
import NewAnalysisDialog from './NewAnalysisDialog';
import ContentLoading from '../../../common/ContentLoading';
import ClearIcon from '@material-ui/icons/Clear';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { Grid } from '@material-ui/core';

const AirbusELAProject = (props) => {
  const navigate = useNavigate();
  const params = useParams();

  const [name, setName] = React.useState('');
  const [user, setUser] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [parsedData, setParsedData] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [open, setOpen] = React.useState(false);
  const [viewAllOpen, setViewAllOpen] = React.useState(false);
  // const [analysisResults, setAnalysisResults] = React.useState([]);
  const [results, setResults] = React.useState([]);

  React.useEffect(() => {
    fetchData();
    fetchUserInfo();
  }, []);

  // logic to fetch initial data for display
  const fetchData = () => {
    return new Promise((resolve, reject) => {
      Auth.currentSession().then((session) => {
        axios
          .get(`${cfg.apiUrl}/app/airbus-ela/project/${params.id}`, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: session.getIdToken().jwtToken,
            },
          })
          .then((resp) => {
            if (resp.status === 200) {
              setName(resp.data.name);
              setData(resp.data.analyses);
              setParsedData(resp.data.analyses);
              setOpen(resp.data.length < 1);
              setIsLoading(false);
              console.log(resp.data.analyses)
              resolve();
            } else {
              NotificationManager.warning(
                'Something went wrong, please check console for response.',
                'WARNING'
              );
              reject(resp);
            }
          })
          .catch((e) => {
            console.log(e);
            if (e.response || e.request) {
              NotificationManager.error(
                'Something went wrong, please see console for details.',
                'ERROR'
              );
            } else {
              NotificationManager.error(
                'Something went wrong, please see console for details.',
                'ERROR'
              );
            }
            reject(e);
          });
      });
    });
  };

  const fetchUserInfo = () => {
    Auth.currentAuthenticatedUser().then((resp) => {
      setUser(resp);
    });
  }

  // logic to compare and return minDate
  const getMinDate = (data) => {
    let minDate = moment().valueOf();
    for (let i = 0; i < data.length; i++) {
      if (data[i].modified < minDate && data[i].modified !== null) minDate = data[i].modified;
    }
    return minDate;
  };

  // logic for filter data
  // const filter = (filters) => {
  //   filterData(data, filters).then((data) => {
  //     setParsedData(data);
  //   });
  // };
  //logic to sort the data based upon the search
  const sortBySearch = (input) => {
    console.log(data);
    let newData = searchData(data, input, ['name']);
    setParsedData(newData);
  };
  // used for searching analysis'
  // const search = (term) => {
  //   searchData(data, term);
  // };

  // used to refresh the data for display
  const refreshData = () => {
    fetchData();
  };

  // logic to create a new analysis using a post call to the API
  const newAnalysis = () => {
    Auth.currentSession().then((session) => {
      axios
        .post(
          `${cfg.apiUrl}/app/airbus-ela/analysis`,
          {
            projectId: params.id,
            username: user.attributes.email,
          },
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: session.getIdToken().jwtToken,
            },
          }
        )
        .then((resp) => {
          if (resp.status === 200) {
            navigate(`/app/AirbusELA/analysis/${params.id}/${resp.data.id}`);
          } else {
            NotificationManager.warning(
              'Something went wrong, please check console for response.',
              'WARNING'
            );
          }
        })
        .catch((e) => {
          console.log(e);
        });
    });
  };

  // used to open/close drawer
  const toggleDrawer = (open) => () => {
    setViewAllOpen(open);
  };

  // will use to grab output result files for display in drawer
  const grabFiles = (results) => {
    console.log('Passed results: ', results);
    //this.setState({
    //});
  };

  const columns = [
    {
      name: 'Analysis Name',
      selector: (row) => row.name,
      allowOverflow: false,
      cell: (row) => (
        <Button
          classes={{ label: classes.buttonLabel }}
          disableRipple
          disableElevation
          disableFocusRipple
          color={'primary'}
          variant={'text'}
          onClick={() => navigate(`/app/AirbusELA/analysis/${params.id}/${row.id}`)}
        >
          <span className={classes.buttonText}>{row.name}</span>
        </Button>
      ),
      sortable: true,
      //sortField: 'analysisName',
    },
    {
      name: 'Aircraft Type',
      selector: (row) => row.args.aircraftType,
      sortable: true,
      cell: (row) => <span>{row.args.aircraftType == null ? '-' : row.args.aircraftType}</span>,
    },
    {
      name: 'Aircraft MSN',
      selector: (row) => row.args.aircraftMSN,
      sortable: true,
      cell: (row) => <span>{row.args.aircraftMSN == null ? '-' : row.args.aircraftMSN}</span>,
    },
    {
      name: 'Aircraft Effectivity',
      selector: (row) => row.args.aircraftEffectivity,
      sortable: true,
      cell: (row) => (
        <span>{row.args.aircraftEffectivity == null ? '-' : row.args.aircraftEffectivity}</span>
      ),
    },
    {
      name: 'Aircraft Tail',
      selector: (row) => row.args.aircraftTail,
      sortable: true,
      cell: (row) => <span>{row.args.aircraftTail == null ? '-' : row.args.aircraftTail}</span>,
    },
    /*{
        name: 'Status',
        selector: 'status',
        sortable: true,
        cell: (row) => (
          <Typography style={{ color: this.statusColor(row.status) }}>{row.status}</Typography>
        ),
      },*/
    {
      name: 'Last Modified Date',
      selector: (row) => row.modified,
      cell: (row) => <span>{row.modified === null ? '-' : moment(row.modified).format('lll')}</span>,
      sortable: true,
    },
    {
      name: 'Last Modified By',
      selector: (row) => row.lastModifiedBy,
      cell: (row) => <span>{row.lastModifiedBy ? row.lastModifiedBy.split('@')[0] : ''}</span>,
      sortable: true,
    },
    {
      name: 'Actions',
      cell: (row) => (
        <ProjectOptions
          row={row}
          project={params.id}
          user={user}
          updateData={refreshData}
          outputFiles={{ handleSendFiles: grabFiles(results) }}
          functions={{ handleViewAll: toggleDrawer(true) }}
          setIsLoading={setIsLoading}
        />
      ),
      allowOverflow: true,
      right: true,
      //row: row => console.log("Row ID: ", row.analysisName),
      //console.log("Row ID: ", ${row.id})
    },
  ];

  const dialogOptions = {
    title: 'Create New Analysis',
    inputs: [
      {
        type: 'text',
        label: 'Analysis Name (leave blank for auto-generated name)',
        id: 'name',
      },
      {
        type: 'text',
        label: 'Aircraft Type',
        id: 'aircraftType',
      },
      {
        type: 'text',
        label: 'Aircraft MSN',
        id: 'aircraftMSN',
      },
      {
        type: 'text',
        label: 'Aircraft Effectivity',
        id: 'aircraftEffectivity',
      },
      {
        type: 'text',
        label: 'Aircraft Tail',
        id: 'aircraftTail',
      },
    ],
    postUrl: "app/airbus-ela/analysis",
    app: "airbus-ela",
  };

  const { classes } = props;

  return (
    <div>
      {isLoading ? (
        <div>
          <ContentLoading />
        </div>
      ) : (
        <div>
          <NewAnalysisDialog
            handleClose={() => setOpen(false)}
            open={open}
            setOpen={setOpen}
            project={params.id}
            {...dialogOptions}
          />
          <Box className={classes.headerContainer}>
            <Typography variant={'h5'} className={classes.headerTitleContainer}>
              <IconButton disableFocusRipple disableRipple onClick={() => navigate('/app/AirbusELA')}>
                <ArrowBackIcon />
              </IconButton>{' '}
              | {name}
            </Typography>
            <Button variant={'contained'} color={'primary'} onClick={() => setOpen(true)}>
              + New Analysis
            </Button>
          </Box>
          <Card className={classes.tableContainer}>
            <DataTable
              style={{ marginTop: '0px', height: '100%' }}
              columns={columns}
              data={parsedData}
              striped
              pagination
              paginationPerPage={10}
              noHeader
              subHeader
              subHeaderComponent={<ProjectTableHeader sortBySearch={sortBySearch} />}
              selectableRowsComponent={Checkbox}
            />
          </Card>
        </div>
      )}
      <SwipeableDrawer
        anchor="right"
        open={viewAllOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        <div
          tabIndex={0}
          role="button"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <Box m={2} display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant={'h6'}>Output Files</Typography>
            <IconButton disableFocusRipple disableRipple onClick={toggleDrawer(false)}>
              <ClearIcon />
            </IconButton>
          </Box>

          <CardContent>
            <Grid container>
              <Grid item m={0.7} sm={12} md={7}>
                <Typography variant={'caption'}>Run Time</Typography>
              </Grid>
              <Grid item sm={12} md={5}>
                <Typography variant={'caption'}>Output Files</Typography>
              </Grid>

              <Box width="100%"></Box>
              <Box width="100%">
                {/*{sortedArray.map((file, index) => {
                return (
                  <React.Fragment key={file.id}>
                    <Divider />
                    <Box m={0.7} display="flex" flexDirection="row" width="100%" key={file.id}>
                      <Grid item sm={12} md={7} xl={7}>
                        <Typography variant={'caption'} fontSize="14px">
                          {moment(file.runDate).format('lll')}
                        </Typography>
                      </Grid>
                      <Grid item sm={12} md={5} xl={5}>
                        <Link
                          component="button"
                          variant="body2"
                          //onClick={(e) => downloadFile(file)}
                        >
                          {getFilename(file.url)}
                        </Link>
                      </Grid>
                    </Box>

                  </React.Fragment>
                );
              })*/}
              </Box>
            </Grid>
          </CardContent>
        </div>
      </SwipeableDrawer>
    </div>
  );
};

export default withStyles(ProjectStyles, { withTheme: true })(withRouter(AirbusELAProject));
